//ClearFilterButtonControlView.js

import { View } from 'backbone';

import BaseControlView from 'BaseControlView.js';
import template from 'report/control-clear-filter-button.ejs';
import eventBus         from 'EventBus.js';
//=====================================================================
//
// An instance of this view represents a clear filter button control
//
// Rene Lopez, September 2016
//
//=====================================================================
class ClearFilterButtonControlView extends BaseControlView  {

        initialize( opts ) {
            super.initialize( opts );

            this.template = template;

            this.tagName = 'div';
            this.listenTo( eventBus, 'ButtonThemeChange', this.themeChangeRender);
            
            return this;
        }
    
        // Neighbor aligner uses this polymorphic property, looking for
        // value 'BaseStaticTextControl'
        get kind() {
            return 'ClearFilterControlButtonControlView';
        }
}

export default ClearFilterButtonControlView;
